import React from 'react';
import './NotionDataTable.css';

const LoadingTable = () => {
  return (
    <div className="notion-data-container">
      <div className="loading">Загрузка данных...</div>
    </div>
  );
};

export default LoadingTable;

